import { render, staticRenderFns } from "./LedgerTab.vue?vue&type=template&id=90d285f6&scoped=true"
import script from "./LedgerTab.vue?vue&type=script&lang=js"
export * from "./LedgerTab.vue?vue&type=script&lang=js"
import style0 from "./LedgerTab.vue?vue&type=style&index=0&id=90d285f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d285f6",
  null
  
)

export default component.exports